export enum PaymentsReservoir {
  PAYMENT_METHODS_LIBRARY = 'PAGOS_BIBLIOTECA',
  PAYMENT_METHODS_CATEGORIES = 'PAGOS_MEDIOS_DE_PAGOS_CATEGORIA',
  PAYMENT_METHODS_ITEMS = 'PAGOS_MEDIOS_DE_PAGOS',
}
